import React, { useState } from "react";
import * as XLSX from "xlsx";
import { FORM_FIELDS } from "../../Constants";
import { itemServices } from "../../../../Services";

const PriceListImportArea = ({ setStore, taxObligation }) => {
  const { STORE_DATA } = FORM_FIELDS;
  const { PRICE_LIST_DATA } = STORE_DATA;

  const inputFile = React.useRef(null);

  const [error, setError] = useState(null);

  const handleFileUpload = (file) => {
    setError();

    if (!file) {
      setStore({});
      return;
    }

    const fileExt = file.name.split(".").pop();

    if (!["csv", "xlsx", "xls"].includes(fileExt)) {
      setError("Dozvoljeni formati su: .csv, .xlsx, .xls");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      // Now you have access to the sheet data, you can parse and process it here
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const mappedData = jsonData.map((item) => ({
        [PRICE_LIST_DATA.ID.name]: item[PRICE_LIST_DATA.ID.title],
        [PRICE_LIST_DATA.NAME.name]: item[PRICE_LIST_DATA.NAME.title],
        [PRICE_LIST_DATA.CODE.name]: item[PRICE_LIST_DATA.CODE.title],
        [PRICE_LIST_DATA.BAR_CODE.name]: item[PRICE_LIST_DATA.BAR_CODE.title],
        [PRICE_LIST_DATA.DESCRIPTION.name]:
          item[PRICE_LIST_DATA.DESCRIPTION.title],
        [PRICE_LIST_DATA.IS_SERVICE.name]:
          item[PRICE_LIST_DATA.IS_SERVICE.title] === "Da",
        [PRICE_LIST_DATA.UNIT_OF_MEASURE.name]:
          item[PRICE_LIST_DATA.UNIT_OF_MEASURE.title],
        [PRICE_LIST_DATA.TAX_RATE.name]: item[PRICE_LIST_DATA.TAX_RATE.title],
        [PRICE_LIST_DATA.ITEM_GROUP.name]:
          item[PRICE_LIST_DATA.ITEM_GROUP.title],
        [PRICE_LIST_DATA.PRICE.name]: item[PRICE_LIST_DATA.PRICE.title],
        [PRICE_LIST_DATA.PN.name]: item[PRICE_LIST_DATA.PN.title],
        [PRICE_LIST_DATA.PP.name]: item[PRICE_LIST_DATA.PP.title],
      }));

      itemServices
        .bulkImportValidateOnboarding({
          body: { taxObligation: !!taxObligation, data: mappedData },
        })
        .then((res) => {
          if (res?.data?.success === true) {
            setStore({
              [PRICE_LIST_DATA.name]: res?.data?.data?.items || [],
              [PRICE_LIST_DATA.FILE.name]: file,
              priceListTableData: mappedData,
              invalidRows: null,
            });

            return;
          }

          if (res?.data?.success === false) {
            setStore({
              [PRICE_LIST_DATA.name]: [],
              priceListTableData: mappedData,
              invalidRows: res?.data?.errors,
            });
          }
        })
        .catch((err) => {
          console.log("ERR ", err);
        });
    };
    reader.readAsArrayBuffer(file);
  };

  const handleOnDrop = (e) => {
    e.preventDefault();
    if (e?.dataTransfer?.items?.length !== 1) {
      setError("Dozvoljen je unos samo jedne datoteke.");
      return;
    }
    const file = e.dataTransfer.items[0].getAsFile();
    handleFileUpload(file);
  };

  const handleOnChange = (e) => {
    const file = e.target.files[0];
    handleFileUpload(file);
  };

  return (
    <>
      {error && <div className="invalid-record my-3 p-3">{error}</div>}
      <div
        className="csv-import-container my-3"
        onDrop={handleOnDrop}
        onDragOver={(e) => e.preventDefault()}
      >
        Povucite datoteku u ovo polje ili <br />
        <button
          className="btn btn-primary"
          onClick={() => inputFile.current.click()}
        >
          Odaberite datoteku
        </button>
      </div>
      <input
        type="file"
        accept=".csv, .xlsx, .xls"
        id="file"
        ref={inputFile}
        onChange={handleOnChange}
        style={{ display: "none" }}
      />
    </>
  );
};

export default PriceListImportArea;
